/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseSuccessResponseData,
    PressReleaseSuccessResponseDataFromJSON,
    PressReleaseSuccessResponseDataFromJSONTyped,
    PressReleaseSuccessResponseDataToJSON,
} from './PressReleaseSuccessResponseData';

/**
 * POST /press_release/{release_id}/auto_save
 * @export
 * @interface AutoSavePressReleaseResponse
 */
export interface AutoSavePressReleaseResponse {
    /**
     * 
     * @type {number}
     * @memberof AutoSavePressReleaseResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof AutoSavePressReleaseResponse
     */
    message: string;
    /**
     * 
     * @type {PressReleaseSuccessResponseData}
     * @memberof AutoSavePressReleaseResponse
     */
    data: PressReleaseSuccessResponseData;
}

export function AutoSavePressReleaseResponseFromJSON(json: any): AutoSavePressReleaseResponse {
    return AutoSavePressReleaseResponseFromJSONTyped(json, false);
}

export function AutoSavePressReleaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoSavePressReleaseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressReleaseSuccessResponseDataFromJSON(json['data']),
    };
}

export function AutoSavePressReleaseResponseToJSON(value?: AutoSavePressReleaseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressReleaseSuccessResponseDataToJSON(value.data),
    };
}

